module.exports = __webpack_public_path__ + "static/features_img-21330c43f4bc3f1a7b5c10a81d92362e.png";